<template>
    <div class="position-relative">
        <div id="Wizard-steps" v-if="step !== 4">
            <div class="container">
                <div class="row justify-content-lg-start justify-content-center">
                    <div class="col-11 col-lg-8 px-0 position-relative">
                        <div class="wizard-steps-place px-sm-0 px-2">
                            <router-view
                                :cardData = "campaignData"
                                @setChildEvent = "setChildEvent"
                                @loadData = "loadData"
                                @setData="setData"
                                @resetData="resetData"
                                @disableNext="disableNext"
                                @showNext = "showNext = $event"
                            />
                            <div id="step-wrapper" class="step-wrapper position-absolute d-lg-block d-none">
                                <div class="step-by-step">
                                    <ul class="step-list p-0">
                                        <li v-for="(stepItem, number) in stepsToShow"
                                            :key="`${number}-${stepItem.pathName}`"
                                            id="step-item"
                                            class="step-item d-flex"
                                            :class="{activeStep: $route.path === stepItem.pathName}">
                                            <div
                                                class="step-circle align-self-center d-flex"
                                                :data-checked="step > stepItem.index">
                                                <p id="step-number" class="p4n text-center mx-auto">{{ number + 1 }}</p>
                                            </div>
                                            <div class="step-text ml-4 d-flex align-items-center">
                                                <p class="p2b mb-0">{{ stepItem.title }}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="wizard-steps-footer pt-3">
                                <div class="wizard-action-buttons d-flex justify-content-between">
                                    <button
                                        @click="cancel"
                                        id="cancel-button"
                                        class="cancel-action p2b unColor_button ml-3">
                                        Cancel
                                    </button>
                                    <div class="d-flex">
                                        <button
                                            v-if="(step >= 1 && step < 5) && !previewsShow"
                                            @click="changeStep(-1)"
                                            id="prev-button"
                                            class="align-content-around prev-action p2b unColor_button mr-5">
                                            Previous
                                        </button>
                                        <button
                                            v-if="step < 4"
                                            @click="changeStep(1)"
                                            id="next-button"
                                            :disabled="campaignData && !campaignData.project_id && !$route.query.id || disabledNext"
                                            class=" next-action p2b phiolet_button mr-3">
                                                <span v-if="step === 0 || step === 1 || showNext">
                                                    Next
                                                </span>
                                                <span v-else>
                                                    Skip
                                                </span>
                                        </button>
                                    </div>
                                </div>
                                <div class="need-help position-absolute d-lg-flex d-none align-items-center align-self-center">
                                    <img
                                        :src="ICON_QUESTION"
                                        alt="Need Help">
                                    <a  
                                        id="help-link"
                                        class="c16 p2n mb-0 ml-1"
                                        target="_blank"
                                        @click="toCrosspromHelp"
                                        href="https://help.crossprom.com/">
                                        Need HELP?
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="preview-step" v-if="step === 4" class="pt-4">
            <div class="position-absolute preview-banner w-100">
                <p class="p4b c16 text-center m-0 py-2">
                    Preview
                </p>
            </div>
            <router-view />
            <div class="preview-footer d-flex justify-content-end align-items-center px-5">
                <router-link
                    class="p2b phiolet_button mr-3"
                    id="prev-button"
                    :to="{path: '/wizard/add-updates', query: {...$route.query, id: $route.query.id}}">
                    Previous
                </router-link>
                <a 
                    id="next-button"
                    @click.prevent="goToVerify"
                    class="p2b phiolet_button mr-3">   
                    Next
                </a>
            </div>
        </div>
        <UnsavedChanges
            v-if="prompt || parentPrompt"
            title="Do you want to leave it in drafts?"
            text="You can always continue from your drafts"
            save-text="Yes"
            @submit="goToStepOne"
            @cancel="onModalHide"
            @no="removeFromDrafts"
            @close="onModalHide"/>
    </div>
</template>

<script>
import { getDataByDocId, deleteData } from "../firebaseCRUD";
import {DEFAULT_CAMPAIGN_COLLECTION} from "../firebase";
import { ICON_QUESTION } from "../constants";
import UnsavedChanges from '@/popups/UnsavedChanges'
import {mapGetters} from 'vuex'

export default {
    name: "WizardSteps",
    components: {
        UnsavedChanges
    },
    data() {
        return {
            steps: [
                { pathName: '/wizard', index: 0, title: 'Add your campaign to the platform' },
                { pathName: '/wizard/edit-campaign', index: 1, title: 'Your Campaign' },
                { pathName: '/wizard/add-cross-prom-info', index: 2, title: 'Add CrossProm Info' },
                { pathName: '/wizard/add-updates', index: 3, title: 'Add your updates schedule' },
                { pathName: '/wizard/preview-campaign', index: 4, title: '' },
                { pathName: '/wizard/verify-campaign', index: 5, title: 'Verify Your Campaign' },
            ],
            campaignData: null,
            step: 0,
            showNext: false,
            childEvent: null,
            disabledNext: false,
            ICON_QUESTION,
            prompt: null,
            onPreviewClick: false
        }
    },
    props: ['parentPrompt', 'routeTo'],
    props: {
        parentPrompt: Boolean,
        routeTo: Object,
        changeRoute: Function
    },
    computed: {
        stepsToShow() {
            return this.steps.filter(item => item.title);
        },
        previewsShow() {
            return this.$route.path === '/wizard/edit-campaign' && this.$route.query.indrafts 
        }
    },
    watch: {
        '$route.path': 'onPathChange',
        '$route.query.id': 'loadData',
    },
    mounted() {
        if (this.$route.name && !this.$route.query.id) {
            return this.$router.push('/404').catch(() => {})
        } else {
            this.onPathChange()
            this.loadData()
        }
    },
    methods: {
        goToVerify(){
            this.$router.push({
                path: '/wizard/verify-campaign',
                query: {...this.$route.query, id: this.$route.query.id}
            }).catch(() => {})
        },
        goToStepOne(){
            if(this.onPreviewClick) {
                this.$router.push('/wizard').catch(() => {})
                this.$emit('parentPrompt', false)
                return 
            }
            this.$router.push(this.$route.query.from || '/').catch(() => {})
        },
        removeFromDrafts(){
            deleteData({
                collection: 'drafts',
                id: this.$route.query.id
            })
            .then(() => {
                if(this.onPreviewClick) {
                    this.$emit('parentPrompt', false)
                    this.$router.push('/wizard').catch(() => {})
                    return 
                }
                if(this.parentPrompt) {
                    this.$router.push(this.routeTo.path).catch(() => {})
                }
            })
        },
        onModalHide() {
            this.prompt = null
            this.$emit('parentPrompt', false)
        },
        disableNext(event){
            this.disabledNext = event;
        },
        setData (data) {
            if(!data){
                this.campaignData = null;
            } else {
                this.campaignData = {...this.campaignData, ...data};
            }
        },
        setChildEvent(event) {
            this.childEvent = event;
        },
        cancel: function() {
            this.$router.push(this.$route.query.from || '/browse').catch(() => {})
        },
        async loadData(callback) {
            if (!this.$route.query.id) {
                this.resetData();
                return
            }

            const doc = await getDataByDocId({
                collection: DEFAULT_CAMPAIGN_COLLECTION,
                id: this.$route.query.id
            });

            const data = {...doc.data(), docId: doc.id}
            this.campaignData = data
            if(callback && typeof callback === 'function') callback();
        },

        toCrosspromHelp(){
            this.$ga.event('Help', 'Click', `
                LoggedIn: true,
                Location: Add Wizard
            `)
            
            this.$sendMixpanelEvent('Help Clicked', {
                'Logged In': true,
                'Link Location': 'Add Wizard'
            });
        },
        
        onPathChange() {
            this.step = this.steps.find(item => this.$route.path === item.pathName).index
            this.$emit('step', this.step)
            if(this.$route.query.id) {
                this.disableNext(false)
            }
        },

        resetData () {
            this.setData(null);
            this.childEvent = {}
        },
        async changeStep(direction) {
            this.disableNext(true)
            if(direction === -1 && this.step === 1){
                this.$emit('parentPrompt', true)
                this.onPreviewClick = true
            }

            if(this.childEvent) {
                if (direction === 1 && this.childEvent.next) {
                    await this.childEvent.next();
                }

                if (direction === -1 && this.childEvent.prev) {
                    await this.childEvent.prev();
                }

            }
            this.childEvent = null;
            const currentRoute = this.steps.find(item => this.$route.path === item.pathName);

            if(currentRoute) {
                const currentIndex = currentRoute.index
                this.$router.push({
                    path: this.steps.map(item => item.pathName)[currentIndex + direction],
                    query: this.$route.query
                }).catch(() => {})
            }
        },
    },
}
</script>
<style>

</style>
<style scoped lang="scss">
    div#Wizard-steps {
        margin: 20px auto;
        transform: scale(0.85);

        @media screen and (min-height: 800px) {
            margin: 0 auto;
            margin-top: 48px;
            transform: scale(1)
        }

        .wizard-steps-place {
            position: relative;
            // width: 824px;
            height: 598px;
            background: #FFFFFF;
            box-shadow: 0 18px 23px rgba(0, 0, 0, 0.05);
            border-radius: 5px;

            .step-wrapper {
                min-width: 350px;
                top: 0;
                left: 100%;
                transform: translateX(-28px);

                .step-list {
                    .step-item {
                        margin-top: 35px;

                        &.activeStep {
                            div.step-circle {
                                border: 1px solid #FFFFFF;
                                background: #727CF5;

                                p {
                                    color: #FFFFFF;
                                }
                            }

                            .step-text {
                                p {
                                    color: #FFFFFF;
                                }
                            }
                        }

                        .step-circle {
                            width: 56px;
                            height: 56px;
                            border: 1px solid #F4F4F4;
                            border-radius: 50%;
                            background: #FFFFFF;
                            flex: 0 0 56px;

                            &[data-checked] {
                                background: url("https://firebasestorage.googleapis.com/v0/b/crossprom-firebase.appspot.com/o/img%2Fwizard%2Fstep5%2Fchecked.svg?alt=media&token=d4405778-edec-480d-8aa4-57b9cc5abb50");
                                background-color: #727CF5;
                                background-repeat: no-repeat;
                                background-position: center;

                                p {
                                    display: none;
                                }
                            }

                            p {
                                line-height: 56px;
                                color: #858585;
                            }
                        }

                        .step-text {
                            p {
                                color: #ffffff4d;
                            }
                        }
                    }
                }
            }
        }

        .wizard-steps-footer {
            width: 100%;
            height: 75px;
            border-top: 1px solid #F4F4F4;
            position: absolute;
            bottom: 0;
            left: 0;

            .wizard-action-buttons {
                button {
                    width: 89px;
                    height: 48px;

                    &:disabled, &.done-disabled {
                        background: #B8CDD7 !important;
                        &:hover {
                            box-shadow: none;
                        }
                    }
                }

                a {
                    width: 89px !important;
                    height: 48px !important;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 48px;
                    transition: all 0.2s ease;
                    border: 1px solid transparent;

                    &:hover {
                        color: #FFFFFF !important;
                    }

                    &.cancel-action {
                        color: #727CF5 !important;

                        &:hover {
                            color: #727CF5 !important;
                        }
                    }

                    &.skip-action {
                        color: #8DA0A9;
                        background: none !important;
                        border: 1px solid #8DA0A9 !important;

                        &:hover {
                            color: #FFFFFF;
                            background: #8DA0A9 !important;
                            /*border: 1px solid /*/
                        }
                    }
                }


            }

            .need-help {
                right: 0;
                top: 50%;
                transform: translate(120px, -50%);
                opacity: 0.4;
                cursor: pointer;
                transition: all 0.2s ease;
                a {
                    color: #ffffff !important;
                }
                &:hover {
                    opacity: 1;

                    a {
                        color: #ffffff !important;
                    }
                }

                img {
                    width: 14px;
                }
            }
        }
    }

    #preview-step {
        .preview-footer {
            height: 115px;
            background: #FFFFFF;
            border-bottom: 1px solid #0000001a;
            margin-bottom: 16px;
            a {
                width: 89px !important;
                height: 48px !important;
                display: block;
                line-height: 48px;
                text-align: center;
                color: #FFFFFF;
                transition: all 0.2s ease;

                &:first-child {
                    background: none;
                    border: 1px solid transparent;
                    color: #727CF5 !important;

                    &:hover {
                        border: 1px solid #727CF5;
                        border-radius: 3px;
                        color: #727CF5 !important;
                        box-shadow: none;
                    }
                }

                &:hover {
                    color: #FFFFFF !important;
                }
            }
        }

        .preview-banner {
            background: #0acf9766;
            top: 0;
            z-index: 100;
        }

    }
@media (min-width: 991px) {
    div#Wizard-steps {
        width: 1200px;
        div.wizard-steps-place {
            width: 824px;
        }
    }
}
   
</style>